<div class="input" style="display: flex;">
    <mat-form-field [formGroup]="parentFormGroup" appearance="outline">
        <div class="d-flex">
            <div class="flex-grow-1">
                <mat-select [formControlName]="parentFormControlName">
                    <mat-select-trigger>
                        <ng-container *ngIf="selectedElement">
                            <span *ngIf="selectedElement.html" [innerHTML]="selectedElement.html"></span>
                            <span *ngIf="! selectedElement.html">{{selectedElement.label}}</span>
                        </ng-container>
                    </mat-select-trigger>
                    <mat-option value="" *ngIf="loading">Chargement en cours</mat-option>
                    <mat-option *ngIf="displayNoValue" [value]="undefined">{{noValueLabel}}</mat-option>
                    <mat-option *ngFor="let element of elements" [value]="element.value" [id]="element.value">

                        <span *ngIf="element.html" [innerHTML]="element.html"></span>
                        <span *ngIf="! element.html">{{element.label}}</span>
                    </mat-option>
                </mat-select>
            </div>
            <button mat-icon-button (click)="eraseSelection()" *ngIf="eraseSelectionEnabled && elementControl.value">
                <mat-icon class="color-secondary">delete</mat-icon>
            </button>
        </div>
    </mat-form-field>
</div>

